import { motion } from "framer-motion";

import { styles } from "../styles";
import { ComputersCanvas } from "./canvas";

const Hero = () => {
  return (
    <section className="relative w-full h-screen mx-auto">
      <div className={`absolute inset-0 top-[10vh] sm:top-[15vh] md:top-[18vh] max-w-6xl mx-auto px-4 sm:px-6 md:px-8 flex flex-row items-start gap-2 sm:gap-3 md:gap-4`}>
        <div className='flex flex-col justify-center items-center mt-1 sm:mt-2'>
          <div className='w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 rounded-full bg-[#915EFF]' />
          <div className='w-0.5 h-24 sm:h-36 md:h-36 lg:h-48 violet-gradient' />
        </div>

        <div className="pr-4 sm:pr-0">
          <h1 className={`${styles.heroHeadText} text-white text-2xl xs:text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-snug sm:leading-snug md:leading-snug lg:leading-snug xl:leading-snug`}>
            Hi, I'm <span className='text-[#A39CFF]'>Hussnain Zafar</span>
          </h1>
          <p className={`${styles.heroSubText} mt-2 sm:mt-3 md:mt-4 text-white-100 text-sm sm:text-base md:text-lg lg:text-xl`}>
            <span className="block">Software Engineer (5+ yrs) in Python, AI/ML, Django, FastAPI, full‑stack.</span>
            <span className="block mt-1 sm:mt-1.5 md:mt-2">I build scalable{' '}
              <span className="slide">
                <span className="wrapper">
                  <span className="whitespace-nowrap">🧩 web apps</span>
                  <span className="whitespace-nowrap">🤖 ML systems</span>
                  <span className="whitespace-nowrap">📊 dashboards</span>
                  <span className="whitespace-nowrap">🧪 data tools</span>
                  <span className="whitespace-nowrap">☁️ cloud platforms</span>
                  <span className="whitespace-nowrap">🚀 CI/CD pipelines</span>
                  <span className="whitespace-nowrap">🧭 APIs</span>
                  <span className="whitespace-nowrap">💼 products</span>
                </span>
              </span>
            </span>
          </p>
        </div>
      </div>

      <ComputersCanvas />

      {/* Scroll indicator positioned at bottom of hero section */}
      <div className='absolute bottom-8 sm:bottom-12 left-0 right-0 flex justify-center'>
        <a href='#about' className='block w-auto h-auto'>
          <div className='w-8 h-14 rounded-3xl border-4 border-secondary flex justify-center items-start p-2 mx-auto'>
            <motion.div
              animate={{
                y: [0, 12, 0],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                repeatType: "loop",
                ease: "easeInOut"
              }}
              className='w-3 h-3 rounded-full bg-secondary'
            />
          </div>
          <span className='sr-only'>Scroll down</span>
        </a>
      </div>
    </section>
  );
};

export default Hero;

